// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getIabCategoryListFailed, getIabCategoryListRequested, getIabCategoryListSucceeded } from './select-iab-category.actions';
import { IabCategoryService } from '@par/app/shared/select-iab-category/services/iab-category.service';
import { Store } from '@ngrx/store';
import { selectIabCategoryListResponse } from './select-iab-category.selectors';

@Injectable()
export class SelectIabCategoryEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getIabCategoryListRequested),
      withLatestFrom(this.store.select(selectIabCategoryListResponse)),
      filter(([, response]) => response == null),
      exhaustMap(() => this.service.getIabCategories()
        .pipe(
          map((response) => getIabCategoryListSucceeded({response})),
          catchError(() => of(getIabCategoryListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: IabCategoryService,
    private store: Store,
  ) {
  }
}
